import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useTranslation } from "react-i18next";
//icons
import {
  FaUserAlt,
  FaBookReader,
  FaHeart,
  FaUserEdit,
  FaSignOutAlt,
  FaShoppingBag,
  FaChartBar,
  FaFileInvoice
} from "react-icons/fa";
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//stores
import { useUserStore } from 'stores';

const DropMenuLogged = (props) => {
  const { t } = useTranslation(['header']);
  const { libraryPath } = useAssignedLibrary();
  const { isSpecialConcourseUser } = useUserStore();

  return (
    <DropdownButton
      drop={props.dropDirection}
      className="btn-logged header__button--logged position-relative"
      size="small"
      id="dropdown-basic-button"
      title={
        <>
          <FaUserAlt className="icon-sm" title={t("myaccount")} />
          <span className={` ${props.sticky ? "d-none" : "d-block"}`}>
            {t("myaccount")}
          </span>
        </>
      }
    >
      <Dropdown.Item as={Link} to={libraryPath('perfil')}>
        <FaUserEdit className="icon-sm" />
        {t("myProfile")}
      </Dropdown.Item>
      <Dropdown.Item
        as={Link}
        className="mr-4 d-flex"
        to={libraryPath('mis-libros')}
      >
        <FaBookReader className="icon-sm" color="info" title="Mis Libros" />
        {t("myBooks")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to={libraryPath('favoritos')}>
        <FaHeart className="icon-sm" />
        {t("misFavoritos")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to={libraryPath('order-list')}>
        <FaShoppingBag className="icon-sm" />
        {t("myOrders")}
      </Dropdown.Item>
      {isSpecialConcourseUser && (
        <>
          <Dropdown.Item as={Link} to={libraryPath('order-controls')}>
            <FaChartBar className="icon-sm" />
            {t("orderControl")}
          </Dropdown.Item>
          <Dropdown.Item as={Link} to={libraryPath('mis-pedidos')}>
            <FaFileInvoice className="icon-sm" />
            {t("albaranesYFacturas")}
          </Dropdown.Item>
        </>
      )}
      <Dropdown.Item onClick={() => props.closeSession()}>
        <FaSignOutAlt className="icon-sm" />
        {t("logout")}
      </Dropdown.Item>
    </DropdownButton>
  );
};

export default DropMenuLogged;
